import { css } from "@emotion/core"
import "../../assets/fonts/index.css"

const Base = () => css`
  font-family: SFReg;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.22;
  letter-spacing: -0.25px;
`

export default {
  Base,
}
